export default {
      id: "logo_5-usage",
      viewBox: "0 0 212 59",
      url: __webpack_public_path__ + "img/icons.14f187a1.svg#logo_5",
      toString: function () {
        return this.url;
      }
    }